// @ts-nocheck
import { Button } from "@shared/antd/button";
import React from "react";
import { useJobDescriptionRequests } from "./use-job-description-request";
import Page from "../../hoc/PageContentHoc";
import Section from "../../hoc/Section";
import { Link } from "react-router-dom";
import { JobDescriptionRequestManagement } from "../JobDescriptionRequest/JobDescriptionRequestManagement";
import { IntlShape, useIntl } from "react-intl";
import { TableAdaptive } from "../../common";
import { DEFAULT_DATE_PATTERN, formatDate } from "../../util/Date/Date";
import { IsMobile } from "../../shared/utils/responsive-design";
import { buildPath, getPath } from "../../../path-context";

export const getTableobDescriptionFields = (intl: IntlShape) => [
  {
    title: intl.formatMessage({ id: "requestNumber" }),
    dataIndex: "requestNumber",
    key: "requestNumber",
    sorter: (a, b) => (a.requestNumber || 0) - (b.requestNumber || 0),
    render: (_, record) => (
      <Link to={JobDescriptionRequestManagement.PATH + "/" + record.id}>
        {_}
      </Link>
    ),
  },
  {
    title: intl.formatMessage({ id: "requestDate" }),
    dataIndex: "requestDate",
    key: "requestDate",
    sorter: (a, b) => new Date(a.requestDate).getTime() - new Date(b.requestDate).getTime(),
    render: (_, record) => formatDate(record.requestDate, DEFAULT_DATE_PATTERN),
  },
  {
    title: intl.formatMessage({ id: "status" }),
    dataIndex: "status",
    key: "status",
    sorter: (a, b) => {
      const aName = a.status?._instanceName || "";
      const bName = b.status?._instanceName || "";
      return aName.localeCompare(bName);
    },
    render: (_, record) => record.status?._instanceName,
  },
  {
    title: intl.formatMessage({ id: "positionGroup" }),
    dataIndex: "positionGroup",
    key: "positionGroup",
    sorter: (a, b) => {
      const aName = a.positionGroup?._instanceName || "";
      const bName = b.positionGroup?._instanceName || "";
      return aName.localeCompare(bName);
    },
    render: (_, record) => record?.positionGroup?._instanceName,
  },
];

export const JobDescriptionLists = () => {
  const { data, isLoading } = useJobDescriptionRequests();
  const intl = useIntl();

  const path = `/${buildPath(getPath("jobDescriptionRequest"), { entityId: "new"})}`;
  
  return (
    <Page>
      <IsMobile>
        {isMobile => (
          <Section size={"large"}>
            <div className={"mb-4"}>
              <Link
                to={path}>

                <Button type={"primary"}>
                  {intl.formatMessage({ id: "diCreate" })}
                </Button>
              </Link>
            </div>

            <TableAdaptive
              loading={isLoading}
              dataSource={data}
              isNeedMobile={true}
              isNeedLink={true}
              urlKey={"jobDescriptionRequest"}
              columns={getTableobDescriptionFields(intl)}
              pagination={{
                pageSize: 10,
                showSizeChanger: false,
              }}
            />
          </Section>
        )}
      </IsMobile>
    </Page>
  );
};
